import { render, staticRenderFns } from "./IndexActionRequests.vue?vue&type=template&id=231126a0"
import script from "./IndexActionRequests.vue?vue&type=script&lang=js"
export * from "./IndexActionRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports